import { render, staticRenderFns } from "./FarmStatistics.vue?vue&type=template&id=55202d86&scoped=true"
import script from "./FarmStatistics.vue?vue&type=script&lang=js"
export * from "./FarmStatistics.vue?vue&type=script&lang=js"
import style0 from "./FarmStatistics.vue?vue&type=style&index=0&id=55202d86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55202d86",
  null
  
)

export default component.exports